import * as Sentry from '@sentry/react';

const SentryMessageFilter = [
  'Incorrect username or password.',
  'User does not exist.',
  'jb',
  'db',
  'gmo',
  'Object captured as promise rejection with keys: details, message, status',
  'Vd',
  'Yd',
  'wd',
];
const SentryTypeFilter = ['NetworkError', 'UserAlreadyAuthenticatedException'];

export const ignoredSentryEvents = (event: Sentry.ErrorEvent): boolean => {
  const values = event.exception?.values || [];
  const typeMatches = values.some(
    (v) => v?.type && SentryTypeFilter.includes(v.type),
  );
  const messageMatches = values.some(
    (m) => m?.value && SentryMessageFilter.includes(m.value),
  );

  return typeMatches || messageMatches;
};
